export default "__VITE_ASSET__87c9b5e1__"